<template>
  <div id="box">
    <HeaderView></HeaderView>
    <img
      src="/img/Innovation/images/Innovation-banner_02.jpg"
      alt=""
      class="responsive-img"
    />
   
    <div id="section4" class="section1 animate-on-scroll">
      <h1 class="section-title">食研一体  精准创新</h1>
      <p class="section-desc" v-html="copywriting.yanfa">
      </p>
      <img src="/img/Innovation/images/shili2.jpg" alt="" style="border-radius:20px;">
      <!-- <video preload="auto" src="/video/pinzhicc.mp4" autoplay controls loop muted  class="responsive-video animate-on-scroll"></video> -->
    </div>
    <section id="section3" class="section2 animate-on-scroll">
      <h1 class="section-title">质量管理体系</h1>
      <p class="section-desc2" style="text-align: center;">
        我们将全球通行的严谨标准转化为企业内部的执行铁律，构建了多维度的质量管理壁垒。
      </p>
      <!-- 质量标准轮播图 -->
      <div class="swiper-container-quality animate-on-scroll">
        <div class="swiper-button-prev"></div>
        <div
          class="swiper-button-next"
          style="background: rgb(230, 0, 19)"
        ></div>
        <Swiper
          :key="qualityList.length"
          :slides-per-view="4"
          :breakpoints="{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1440: { slidesPerView: 4 },
          }"
          :space-between="20"
          :loop="true"
          :autoplay="{ delay: 3000, disableOnInteraction: false }"
          :modules="modules"
          :navigation="{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }"
          class="quality-swiper"
        >
          <SwiperSlide
            v-for="(item, idx) in swiperQualityList"
            :key="idx"
            class="quality-slide"
          >
            <div class="quality-slide-content" @click="handleImgClick(item.image)">
              <img :src="item.image" alt="质量标准" class="quality-img" />
            </div>
            <p class="quality-desc">{{ item.title }}</p>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>

    <section id="section2" class="section3 animate-on-scroll">
      <h1 class="section-title">校企科研联创中心</h1>

      <p class="xq-desc" v-html="copywriting.keyan">
      </p>
      <!-- 数据 -->
      <!-- <div class="stat-list">
        <div
          class="stat-item"
          :style="{
            opacity: statAnimated[0] ? 1 : 0,
            transform: statAnimated[0] ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s ease',
          }"
        >
          <div class="stat-number">
            <span>{{ statNumbers[0] }}</span
            ><span class="stat-unit">个</span>
          </div>
          <p>服务大区</p>
        </div>
        <div
          class="stat-item"
          :style="{
            opacity: statAnimated[1] ? 1 : 0,
            transform: statAnimated[1] ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s 0.1s ease',
          }"
        >
          <div class="stat-number">
            <span>{{ statNumbers[1] }}</span
            ><span class="stat-unit">个</span>
          </div>
          <p>全球高校服务</p>
        </div>
        <div
          class="stat-item"
          :style="{
            opacity: statAnimated[2] ? 1 : 0,
            transform: statAnimated[2] ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s 0.2s ease',
          }"
        >
          <div class="stat-number">
            <span>{{ statNumbers[2] }}</span
            ><span class="stat-unit">个</span>
          </div>
          <p>全球高校服务</p>
        </div>
        <div
          class="stat-item"
          :style="{
            opacity: statAnimated[3] ? 1 : 0,
            transform: statAnimated[3] ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s 0.3s ease',
          }"
        >
          <div class="stat-number">
            <span>{{ statNumbers[3] }}</span
            ><span class="stat-unit">个</span>
          </div>
          <p>全球高校服务</p>
        </div>
      </div> -->
    </section>

    <section id="section1" class="section4 animate-on-scroll">
      <h1 class="section-title">源头把控，底线坚守</h1>
      <p class="section-desc2" v-html="copywriting.yuantou">
      </p>
      
      <img src="/img/Innovation/images/Innovation3_03.png" alt="" style="width: 85%; margin:0 auto" />

    </section>
    <section id="section0" class="section5 animate-on-scroll">
      <h1 class="section-title">生产自动化</h1>
      <!-- 生产自动化轮播图 -->
      <div class="swiper-container-auto animate-on-scroll">
        <div class="swiper-button-prev swiper-button-prev2"></div>
        <div
          class="swiper-button-next swiper-button-next2"
          style="background: rgb(230, 0, 19)"
        ></div>
        <Swiper
          :key="qualitys.length"
          :slides-per-view="3"
          :breakpoints="{
            320: { slidesPerView: 1 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }"
          :space-between="20"
          :loop="true"
          :autoplay="{ delay: 3000, disableOnInteraction: false }"
          :modules="modules"
          :navigation="{
            prevEl: '.swiper-button-prev2',
            nextEl: '.swiper-button-next2',
          }"
          class="auto-swiper"
        >
          <SwiperSlide
            v-for="(item, idx) in swiperQualitys"
            :key="idx"
            class="auto-slide"
          >
            <img :src="item.image" alt="生产自动化" class="auto-img" />
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
    <!-- 图片放大模态框 -->
    <transition name="modal-fade">
      <div v-if="modalVisible" class="image-modal" @click="closeModal">
        <div class="modal-content" @click.stop>
          <img :src="modalImage" alt="放大图片" class="modal-image" @error="e=>e.target.src=modalImage.replace('_hd.','.')" />
          <button class="modal-close" @click="closeModal">&times;</button>
        </div>
      </div>
    </transition>
    <FooterView></FooterView>
  </div>
</template>

<script>
import apiServe from "../services/index.js";
import HeaderView from "../components/HeaderView2.vue";
import FooterView from "../components/FooterView.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
export default {
  components: {
    HeaderView,
    Swiper,
    SwiperSlide,
    FooterView,
  },
  data() {
    return {
      copywriting: {},

      modules: [Pagination, Autoplay, Navigation],
      modalVisible: false,
      modalImage: '',
      qualityList: [],
      qualitys: [],
      // 动画数字目标值
      statTargets: [5, 500, 200, 200],
      // 当前动画数字
      statNumbers: [0, 0, 0, 0],
      // 动画完成标记
      statAnimated: [false, false, false, false],
    };
  },
  created() {},
  computed: {
    // 处理生产自动化轮播图数据，当图片数量不足时双倍循环以实现无限滚动
    swiperQualitys() {
      const slidesPerView = 3;
      if (this.qualitys.length <= slidesPerView) {
        // 当图片数量小于等于显示数量时，双倍循环图片
        return [...this.qualitys, ...this.qualitys];
      }
      return this.qualitys;
    },
    // 处理质量标准轮播图数据，当图片数量不足时双倍循环以实现无限滚动
    swiperQualityList() {
      const slidesPerView = 4;
      if (this.qualityList.length <= slidesPerView) {
        // 当图片数量小于等于显示数量时，双倍循环图片
        return [...this.qualityList, ...this.qualityList];
      }
      return this.qualityList;
    },
  },
  mounted() {
    this.fetchData();

    this.initStatAnimation();
    this.initScrollAnimation();
    this.$nextTick(() => {
      const videoElement = this.$el.querySelector('.responsive-video');
      if (videoElement) {
        const videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                videoObserver.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1 }
        );
        videoObserver.observe(videoElement);
      }
      this.scrollToSection();
    });
  },
  methods: {
    fetchData() {
      apiServe.getCopyWriting({}, "get").then((res) => {
       console.log(res, "我是查询接口文案");
        this.copywriting = res.data;
      })
      apiServe.getProductionData({}, "get").then((res) => {
        this.qualityList = res.data.production || [];
        this.qualitys = res.data.qualitys || [];
        // 数据加载完成后确保DOM更新
        this.$nextTick(() => {
          // Swiper组件会自动响应数据变化
          console.log('轮播图数据加载完成');
        });
      })
    },
    // 移动端判断
    isMobile() {
      return window.innerWidth <= 768;
    },
    // 处理图片点击（移动端禁用模态框）
    handleImgClick(imageSrc) {
      if (this.isMobile()) return;
      this.openModal(imageSrc);
    },
    // 打开图片模态框
    openModal(imageSrc) {
      // 若无高清图则回退原图
      const hdSrc = imageSrc.replace(/\.(png|jpg|jpeg)$/i, '_hd.$1');
      this.modalImage = hdSrc;
      this.modalVisible = true;
      document.body.style.overflow = 'hidden';
    },
    // 关闭图片模态框
    closeModal() {
      this.modalVisible = false;
      this.modalImage = '';
      document.body.style.overflow = ''; // 恢复背景滚动
    },
    // 初始化统计动画
    initStatAnimation() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.startStatAnimation();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.5 }
      );
      const statList = this.$el.querySelector(".stat-list");
      if (statList) observer.observe(statList);
    },
    // 开始数字递增动画
    startStatAnimation() {
      this.statTargets.forEach((target, idx) => {
        if (this.statAnimated[idx]) return;
        this.animateNumber(idx, target, 1200); // 1.2s 动画时长
        this.statAnimated[idx] = true;
      });
    },
    // 数字动画核心
    animateNumber(index, target, duration) {
      const startTime = performance.now();
      const step = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // 使用缓动函数
        const easeOut = (t) => 1 - Math.pow(1 - t, 3);
        const current = Math.floor(easeOut(progress) * target);
        this.$set(this.statNumbers, index, current);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          this.$set(this.statNumbers, index, target);
        }
      };
      requestAnimationFrame(step);
    },
    // 初始化滚动动画
    initScrollAnimation() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate");
            }
          });
        },
        { threshold: 0.1 }
      );
      
      const animateElements = this.$el.querySelectorAll(".animate-on-scroll");
      animateElements.forEach((el) => {
        observer.observe(el);
      });
    },
    scrollToSection() {
      const id = this.$route.hash.slice(1) || this.$route.query.section;
      if (!id) return;

      const el = document.getElementById(id);
      if (!el) return;

      const header = document.querySelector('.header');
      const headerHeight = header ? header.offsetHeight : 70;

      const sectionOffsets = {
        section0: 30,
        section1: 30,
        section2: 30,
        section3: 30,
        section4: 30
      };

      const offset = sectionOffsets[id] || 30;

      const scrollToPosition = () => {
        const rect = el.getBoundingClientRect();
        const targetPosition = rect.top + window.scrollY - headerHeight + offset;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        const finalPosition = Math.max(0, Math.min(targetPosition, maxScroll));
        window.scrollTo({ top: finalPosition, behavior: 'smooth' });
      };

      scrollToPosition();

      setTimeout(() => {
        const rect = el.getBoundingClientRect();
        if (Math.abs(rect.top - headerHeight + offset) > 50) {
          scrollToPosition();
        }
      }, 300);
    },
  },
  metaInfo() {
    return {
      title: this.copywriting?.title,
      meta: [
        { name: 'keywords', content: this.copywriting?.keywords },
        { name: 'description', content: this.copywriting?.description}
      ]
    };
  }
};
</script>

<style scoped>


.responsive-img,
img {
  width: 100%;
  height: auto;
  display: block;
}
.responsive-video {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.section1 {
  padding: clamp(2rem, 5vw, 5rem) clamp(3rem, 10vw, 10rem);
  text-align: center;
}
.section2 {
  padding: 0 clamp(3rem, 10vw, 10rem) clamp(4rem, 10vw, 10rem);
  text-align: center;
}
.section3 {
  padding: clamp(2rem, 10vw, 2rem) clamp(3rem, 10vw, 10rem);
  text-align: center;
  background-image: url("../../public/img/Innovation/images/Innovation2_02.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
}
.section4 {
  padding: clamp(2rem, 5vw, 5rem) clamp(2rem, 10vw, 10rem);
  text-align: center;
}
.section5 {
  padding: 0 clamp(3rem, 10vw, 10rem) clamp(2rem, 5vw, 5rem);
  text-align: center;
}
.section-desc {
  width: 93%;
  margin: 0 auto;
  font-size: clamp(1rem, 2.5vw, 1.5rem);
  line-height: 1.4;
  margin-bottom: 3.5rem;
  text-align: center; 
  /* text-indent: 2em; */
  /* color: rgb(137, 138, 137); */
}
@media (min-width: 1350px) {
  .section-desc {
    white-space: nowrap;
  }
}
.xq-desc {
  width: 77%;
  margin: 0 auto;
  font-size: clamp(1rem, 2.5vw, 1.5rem);
  line-height: 1.4;
  margin-top: 20rem;
  text-align: left;
  text-indent: 2em;
}
@media (max-width: 1840px) {
  .xq-desc {
    margin-top: 15rem;
  }
}
.section-desc2 {
  width: 85%;
  margin: 0 auto;
  font-size: clamp(1rem, 2.5vw, 1.5rem);
  line-height: 1.4;
  margin-bottom: 3.5rem;
  color: rgb(137, 138, 137);
  text-align: left;
  text-indent: 2em;
}
.swiper-container-auto {
  width: 85%;
  margin: 0 auto;
  position: relative;
}
.swiper-container-quality {
  width: 100%;
  margin: 2rem auto 0;
  position: relative;
}
.quality-slide {
  display: flex;
  flex-direction: column;
  gap: 1.3rem;

  justify-content: center;
  align-items: center;
}
.quality-img {
  width: 100%;
  height: auto;
  object-fit: cover;
  /* border-radius: 8px; */
}
.quality-slide-content {
  border: 1px solid #3d3d3d;
  border-radius: 12px;
  padding: 1rem 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 轮播图容器动画 */
.swiper-container-quality,
.swiper-container-auto {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.swiper-container-quality.animate,
.swiper-container-auto.animate {
  opacity: 1;
  transform: translateY(0);
}


.section-title {
  font-size: clamp(1.8rem, 5vw, 3rem);
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.2em;
  opacity: 0;
  transform: translateY(30px);
  animation: fadeInUp 0.8s forwards;
}

/* 滚动动画 */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.animate-on-scroll.animate {
  opacity: 1;
  transform: translateY(0);
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.stat-list {
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 4rem;
}
.stat-item {
  text-align: center;
}
.stat-number span:first-child {
  font-size: clamp(1.8rem, 5vw, 3rem);
  font-weight: 500;
  line-height: 1.2;
}
.stat-unit,
.stat-item p {
  font-size: 1rem;
  color: #333;
}
.stat-number {
  display: block;
}

/* 统计数字动画延迟 */
.stat-item:nth-child(2) .stat-number {
  transition-delay: 0.1s;
}
.stat-item:nth-child(3) .stat-number {
  transition-delay: 0.2s;
}
.stat-item:nth-child(4) .stat-number {
  transition-delay: 0.3s;
}
.swiper-button-next,
.swiper-button-prev {
  color: #fff;
  position: absolute;
  top: 130%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  background: #14419e;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 10px;
  /* transition: background 0.3s; */
}
.swiper-button-next2,
.swiper-button-prev2 {
  top: 55%;
}

/* 缩小箭头图标 */
::v-deep(.swiper-button-prev svg),
::v-deep(.swiper-button-next svg) {
  width: 25%;
}
.swiper-button-next:active,
.swiper-button-prev:active {
  background: #e60013;
}
.swiper-button-next {
  right: 46%;
}
.swiper-button-prev {
  left: 46%;
}
.swiper-button-next2 {
  right: -5%;
}
.swiper-button-prev2 {
  left: -5%;
}
/* 视频元素动画 */
.responsive-video {
  opacity: 0;
  transform: scale(0.95);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.responsive-video.animate {
  opacity: 1;
  transform: scale(1);
}


/* 锚点平滑滚动预留导航高度 */
.animate-on-scroll {
  scroll-margin-top: 80px; /* 根据实际导航高度调整 */
}

/* 响应式调整 */
@media (max-width: 768px) {
  .quality-slide-content{
    padding: 1rem 3rem;
  }
  .section1 {
    padding: 3rem 5rem;
  }
  .section3 {
    height: auto;
    min-height: 540px;

  }
  .xq-desc{
    width: 100%;
    margin-top: 11rem;
}
  
  .section-desc {
    width: 100%;
    font-size: 1rem;
    line-height: 1.4;
  }
  
  .section-desc2 {
    width: 100%;

    font-size: 1rem;
    line-height: 1.4;
  }
  .section-title {
    font-size: 1.8rem;
  }
  .swiper-container-quality {
    width: 89%;
  }
  .quality-img {
    height: auto;
  }
  .swiper-button-prev-quality,
  .swiper-button-next-quality {
    width: 24px;
    height: 24px;
    right: 10px;
    left: auto;
    transform: translateY(-50%) scale(0.8);
  }
  .swiper-button-prev-quality {
    left: 10px;
    right: auto;
  }
}

@media (max-width: 480px) {
  .section1 {
    padding: 2rem 3rem;
  }
  .section3 {
    height: auto;
  }

  .section-desc {
    font-size: 1rem;
    line-height: 1.4;
  }
  .section-desc2 {
    font-size: 1rem;
    line-height: 1.4;
  }
  .section-title {
    font-size: 1.8rem;
  }
  .quality-img {
    height: auto;
  }

  .swiper-button-next,
.swiper-button-prev {
  top: 118%;
}
.swiper-button-next2,
.swiper-button-prev2 {
  top: 55%;
}

.swiper-button-next {
  right: 33%;
}
.swiper-button-prev {
  left: 33%;
}
.swiper-button-next2 {
  right: -22%;
}
.swiper-button-prev2 {
  left: -22%;
}

/* 移动端统计数字模块优化 */
  .stat-list {
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    margin-top: 1.5rem;
  }
  .stat-item {
    flex: 0 1 45%;
    margin: 0;
  }
  .stat-number span:first-child {
    font-size: clamp(1.2rem, 3.5vw, 1.8rem);
  }
  .stat-unit,
  .stat-item p {
    font-size: 0.85rem;
  }
}

/* 图片放大模态框样式 */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: zoom-out;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  cursor: default;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-image {
  width: 605px;
  height: auto;
  object-fit: contain;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  background: #f5f5f5;
  pointer-events: none;
}

.modal-close {
  opacity: 0;
  position: absolute;
  top: -50px;
  right: 455px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 2.5rem;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;
  z-index: 10000;
}

.modal-close:hover {
  color: #e60013;
}

/* 模态框动画 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-active .modal-content,
.modal-fade-leave-active .modal-content {
  transition: transform 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .modal-content {
  transform: scale(0.9);
}

.modal-fade-leave-to .modal-content {
  transform: scale(0.9);
}

/* 移动端模态框优化 */
@media (max-width: 768px) {
  .modal-content {
    max-width: 95vw;
    max-height: 95vh;
  }
  
  .modal-close {
    top: -50px;
    font-size: 2rem;
  }
}
</style>